var account = "Fiók";
var accountSettings = "Fiókbeállítások";
var charging = "Töltés";
var contactInfo = "Elérhetőségek";
var dashboard = "Műszerfal";
var home = "Kezdőlap";
var myProducts = "Termékeim";
var orderHistory = "Korábbi megrendelések";
var paymentMethod = "Fizetési mód";
var profileSettings = "Profilbeállítások";
var referAndEarn = "Az ajánlással Ön is jól járhat";
var signOut = "Kijelentkezés";
var hu_HU = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, hu_HU as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
